module.exports = __webpack_public_path__ + "img/1F1F9-1F1F9.d53a3b1e.svg";